<template>
    <div>
      <ToastAlert :is-active="toastAlert" :type="typeMsg" :message="msg" />
      <div class="flex min-h-screen bg-dark_bg-100 text-white h-full">
        <div class="hidden w-1/2 sm:flex items-center justify-center">
          <div class="mt-20">
            <img
              src="@/assets/imgs/door.jpg"
              alt="Tuin hora de hacer magia"
              class="w-full h-full max-h-screen rounded-lg shadow-lg"
            />
          </div>
        </div>
  
        <div
          v-if="page_view == 'login'"
          class="w-full sm:w-1/2 flex flex-col items-center justify-center bg-black min-h-screen"
        >
          <img
            src="@/assets/imgs/GABI.svg"
            alt="Logo"
            class="object-contain w-20"
          />
          <h3 class="mb-6"></h3>
          <!-- card -->
          <div class="w-3/4 max-w-md bg-dark_bg-100 p-5 rounded-sm">
            <h2 class="text-2xl font-semibold mb-6">Iniciar sesión</h2>
            <div class="mb-4">
              <fwb-input
                v-model="email"
                label="Email"
                type="email"
                required=""
                label-class="text-white"
                class="custom-label"
                placeholder="hola@tuin.ai"
              />
            </div>
            <div class="mb-4">
              <fwb-input
                v-model="password"
                label="Contraseña"
                type="password"
                required=""
                label-class="text-white"
                class="custom-label"
                placeholder="Ingresa tu contraseña"
              />
            </div>
            <div class="mb-4 flex items-center justify-between">
              <div>
                <!-- <fwb-input
                    v-model="remember"
                    placeholder="Test@gmail.com" 
                    label="Email"
                  /> -->
  
                <fwb-checkbox v-model="remember">
                  <fwb-a class="text-white"> Recordar contraseña </fwb-a>
                </fwb-checkbox>
              </div>
              
              <router-link
                to="/forgot-password"
                class="text-tuin-100 text-sm cursor-pointer"
              >
                ¿Olvidaste tu contraseña?
              </router-link>         
            </div>
            <button
              class="w-full py-2 bg-tuin-100 hover:bg-tuin-100 rounded-md text-white font-semibold"
              @click="auth()"
            >
              Ingresar
            </button>
            
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref } from "vue";
  import { FwbInput, FwbCheckbox } from "flowbite-vue";
  import axios from "axios";
  import { useRouter } from "vue-router";
  let router = useRouter();
  import ToastAlert from "@/commond/ToastAlert.vue";
  import { useStore } from "vuex";
  let store = useStore();
  
  //import axios from "axios";
  
  let page_view = ref("login");
  
  let email = ref("");
  let password = ref("");
  let toastAlert = ref(false);
  let typeMsg = ref("");
  let msg = ref("");
  //let remember = ref("");
  
  
  async function auth() {
  if (email.value === "") {
    showToast("danger", "Debes agregar un email válido");
    return false;
  }
  if (password.value === "") {
    showToast("danger", "Debes agregar tu contraseña");
    return false;
  }
  let params = { email: email.value, password: password.value };
  const url = `${process.env.VUE_APP_API_BASE_URL}/login`;
  console.log(":antena_de_satélite: Enviando POST a:", url); // Ver la URL exacta
  try {
    const response = await axios.post(url, params);
    console.log(":marca_de_verificación_blanca: Respuesta completa:", response);
    if (response && response.status === 200) {
      const userSession = response.data.resp;
      const isAdmin = userSession.rols.some(
        (rol) => rol.rol_name === "Admin"
      );
      if (!isAdmin) {
        showToast("danger", "No tienes acceso a esta aplicación");
        return;
      }
      store.dispatch("saveUserSession", userSession);
      switch (userSession.step) {
        case 0:
        case 3:
          router.push({ name: "dashboard" });
          break;
        case 1:
          router.push({ name: "info_company" });
          break;
        case 2:
          router.push({ name: "info_networks" });
          break;
        default:
          router.push({ name: "dashboard" });
      }
    }
  } catch (error) {
    if (error.response && error.response.status === 422) {
      showToast("danger", error.response.data.message);
    } else {
      showToast("danger", "Ocurrió un error inesperado.");
      console.error(":x: Error:", error);
      if (error.config) {
        console.error(":lupa: URL solicitada:", error.config.url);
      }
    }
  }
}

function showToast(type, message) {
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast();
  }, 3000);
}

  
  async function closeToast() {
    toastAlert.value = false;
    typeMsg.value = "";
    msg.value = "";
  }
  
  </script>
    
  <style scoped>
  /* Si el label tiene clases predeterminadas de Flowbite/Tailwind, puedes sobrescribirlas */
  ::v-deep .custom-label label {
    @apply text-white;
  }
  
  /* También puedes apuntar directamente al selector completo */
  ::v-deep .custom-label label.block.mb-2.text-sm.font-medium {
    @apply text-white;
  }
  </style>